<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Mark as declined
      @if (!loading && quote) {
        <p class="subtitle">Quote #{{quote.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="decline()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                @if (params['declined_date']) {
                  <ion-input class="modal-input" readonly="true" label="Declined date" labelPlacement="stacked" fill="outline" value={{formatted_declined_date}} (click)="presentDateTimePickerModal()"></ion-input>
                }
                @if (!params['declined_date']) {
                  <ion-input class="modal-input" readonly="true" label="Declined date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>